import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function CsvIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 18} height={height || 19.5} viewBox="0 0 18 19.5">
      <g fill={color || "#bbb"}>
        <path
          data-name="Path 1049"
          d="M362.8 178.8h-11.2a1.705 1.705 0 00-1.7 1.7v13.2a1.705 1.705 0 001.7 1.7h11.2a1.705 1.705 0 001.7-1.7v-13.2a1.705 1.705 0 00-1.7-1.7zm0 14.9h-11.2v-13.2h11.2zm-14.6-11h-1.7v13.9a1.705 1.705 0 001.7 1.7h12.9v-1.7h-12.9z"
          transform="translate(-346.5 -178.8)"
        />
        <g data-name="Group 110">
          <path
            data-name="Path 1050"
            d="M352.8 188.678v-3.1a1.327 1.327 0 112.654 0v.655h-.831v-.655a.49.49 0 10-.976 0v3.1a.49.49 0 10.976 0v-.8h.831v.8a1.327 1.327 0 11-2.654 0z"
            transform="translate(-346.5 -178.8)"
          />
          <path
            data-name="Path 1051"
            d="M355.845 188.63v-.2l.816-.088v.208c0 .408.208.656.544.656a.5.5 0 00.543-.536c0-.352-.144-.607-.775-1.207-.84-.792-1.08-1.224-1.08-1.839a1.291 1.291 0 112.575.008v.143l-.816.088v-.163c0-.432-.168-.656-.464-.656s-.463.184-.463.535.175.608.775 1.208c.816.815 1.08 1.223 1.08 1.839a1.368 1.368 0 11-2.735 0z"
            transform="translate(-346.5 -178.8)"
          />
          <path
            data-name="Path 1052"
            d="M361.8 184.328l-.927 5.6h-1.135l-.928-5.6h.863l.64 4.4.64-4.4z"
            transform="translate(-346.5 -178.8)"
          />
        </g>
      </g>
    </svg>
  );
}
